import { ITranslation } from 'marketing-site/lib/translation/@types/translations'

export type TranslationsMap = Map<string, string>

export default function buildTranslationsMap(translations: ITranslation[]): TranslationsMap {
  const translationsMap = new Map<string, string>()
  for (const translation of translations) {
    translationsMap.set(translation.key, translation.value)
  }

  return translationsMap
}
